<template>
    <div>
        <div class="w-full mb-2">
            <v-select
                :map-keydown="keepEscapeInsideOpenSelect"
                v-if="availableForms"
                :options="availableForms"
                :reduce="(option) => option.slug"
                label="title"
                v-model="value"
            >
                <template v-if="required" #search="{ attributes, events }">
                    <input
                        class="vs__search"
                        :required="!value"
                        v-bind="attributes"
                        v-on="events"
                    />
                </template>
            </v-select>
            <mf-spinner-medium v-else class="w-16 h-8"></mf-spinner-medium>
        </div>

        <a :href="manageFormsUrl" class="myflow-basic-button--secondary" target="_blank">
            {{ manageButtonText }}
        </a>
        <button
            type="button"
            class="ml-2 myflow-basic-button--warning"
            @click.prevent="loadAvailableForms()"
        >
            {{ reloadButtonText }}
        </button>
    </div>
</template>

<script>
import axios from 'axios';
import vSelect from 'vue-select';
import { keepEscapeInsideOpenSelect } from '@/utils/vueSelect.js';

export default {
    components: {
        vSelect,
    },
    props: {
        modelValue: {
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        manageText: {
            type: String,
            default: null,
        },
        reloadText: {
            type: String,
            default: null,
        },
    },
    emits: ['update:modelValue', 'validationUpdate'],
    data() {
        return {
            availableForms: null,
            value: this.modelValue,
        };
    },
    computed: {
        manageFormsUrl() {
            return route('forms.index');
        },
        manageButtonText() {
            return this.manageText ?? _mft('pagebuilderBlock:form.manageForms');
        },
        reloadButtonText() {
            return this.reloadText ?? _mft('pagebuilderBlock:form.reloadAvailableForms');
        },
    },
    async mounted() {
        await this.loadAvailableForms();
        this.captureModelValue();
        this.validate();
    },
    watch: {
        modelValue() {
            this.captureModelValue();
        },
        value(newValue, oldValue) {
            this.validate();

            if (newValue === oldValue) {
                return;
            }

            this.$emit('update:modelValue', newValue);
        },
    },
    methods: {
        keepEscapeInsideOpenSelect,
        async loadAvailableForms() {
            this.availableForms = null;

            const response = await axios.get(route('forms.index'));
            this.availableForms = response.data.data.filter((form) => form.published);

            if (!this.availableForms.find((form) => form.slug === this.value)) {
                this.value = null;
            }
        },
        captureModelValue() {
            if (this.value === this.modelValue) {
                return;
            }

            this.value = this.modelValue;
        },
        validate() {
            const validates = !this.required || Boolean(this.value);
            this.$emit('validationUpdate', validates);
        },
    },
};
</script>
